export const getDropdownValue = (ddlData) => {
    if (!ddlData) return;

    let exctractedDropdownValue = ddlData && typeof ddlData === 'object' ? ddlData.value : ddlData;


    return exctractedDropdownValue;

};

export const getSelectedDropdownObject = (selectedValue, optionList) => {
    if (!(selectedValue || optionList)) return;

    let extractedValue = getDropdownValue(selectedValue);

    let selectedValueObj = optionList.find(item => item.value === extractedValue);

    return selectedValueObj
};